export type MoveTarget = 'start' | 'end' | number

/** Returns a new array with the item at `fromIndex` moved to `target`. */
export function moveInArray<T>(list: readonly T[], fromIndex: number, target: MoveTarget): T[] {
  if (fromIndex < 0 || fromIndex >= list.length) return [...list]
  const next = [...list]
  const [moved] = next.splice(fromIndex, 1)
  if (moved === undefined) return [...list]
  let to: number
  if (target === 'start') to = 0
  else if (target === 'end') to = next.length
  else to = Math.max(0, Math.min(next.length, target))
  next.splice(to, 0, moved)
  return next
}

/** Moves the entry with `id` within a list of objects that have an `id`. */
export function moveById<T extends { id: string }>(list: readonly T[], id: string, target: MoveTarget): T[] {
  return moveInArray(list, list.findIndex((entry) => entry.id === id), target)
}
